<template>
  <transition name="modal-fade">
  <div class="rhg-modal-filters" @click="clickOutOfModal">
    <div class="rhg-modal-filters-content">
      <div class="rhg-modal-filters-header">
        <span>{{ translate('desFilters') }}</span>
        <i class="rhg-font-icon--close-icon" @click="clickCloseIcon" />
      </div>
      <div class="rhg-modal-filters-body">
        <FilterSection v-for="filter in filters"
          :key="filter.id"
          :title="filter.title"
          :id="filter.id"
          :filterList="filter.list"
          :maxRange="filter.maxRange"
          :minRange="filter.minRange"
          :isSectionExpanded="filter.isSectionExpanded"
          :selectedFilters="selectedFilters"
          :isMobile="isMobile"
          :expandAll="expandAll"
          :clearPrice="clearPrice"
          @toggleExpand="toggleExpand"
          @updatePriceFilter="updatePriceFilter"
          @filterSelected="filterSelected"
          @unselectFilter="unselectFilter"
          @toggleClearPrice="toggleClearPrice" />
      </div>
      <div class="rhg-modal-filters-bottom">
        <div class="rhg-separator"></div>
        <div class="rhg-modal-filter-buttons">
          <button class="rhg-modal-filters-clear" @click="clearFilters">{{translate('promoFiltersClear')}}</button>
          <button ref="doneButton" class="rhg-modal-filters-done" @click="applyFilters" :disabled="isLoading">
            <span v-if="!isLoading">{{translate('promoFiltersDone')}} <span class="rhg-modal-filters-done-numHotels">({{ numHotels }} {{translate('desHotels')}})</span></span>
            <span v-else><b-spinner></b-spinner></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import FilterSection from '@/components/filters/FilterSection.vue'

export default {
  name: 'FiltersModal',
  emits: ['updatePriceFilter', 'clickOutOfModal', 'closeModal', 'filterSelected', 'unselectFilter', 'toggleExpand', 'applyFilters'],
  components: {
    FilterSection
  },
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedFilters: {
      type: Array,
      required: true,
      default: () => []
    },
    numHotels: {
      type: Number,
      required: true,
      default: 0
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => ({
    isMobile: window.innerWidth <= 992,
    isSelected: false,
    expandAll: false,
    clearPrice: false
  }),
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    numHotels (newValue) {
      if (newValue === 0) this.$refs.doneButton.disabled = true
      else if (this.$refs.doneButton.disabled) this.$refs.doneButton.disabled = false
    }
  },
  methods: {
    clickOutOfModal (event) {
      if (event.target.classList.value === 'rhg-modal-filters') {
        this.clearFilters()
        this.$emit('closeModal')
      }
    },
    clickCloseIcon () {
      this.clearFilters()
      this.$emit('closeModal')
    },
    handleResize () {
      this.isMobile = window.innerWidth <= 992

      if (!this.isMobile) this.expandAll = true
      else this.expandAll = false
    },
    updatePriceFilter (prices) {
      this.$emit('updatePriceFilter', prices)
    },
    filterSelected (code, id) {
      this.$emit('filterSelected', code, id)
    },
    unselectFilter (code) {
      this.$emit('unselectFilter', code)
    },
    applyFilters () {
      this.$emit('applyFilters')
    },
    clearFilters () {
      this.clearPrice = true
      this.$emit('clearFilters')
    },
    toggleExpand (id) {
      this.$emit('toggleExpand', id)
    },
    toggleClearPrice () {
      this.clearPrice = !this.clearPrice
    }
  }
}
</script>

<style lang="scss">
.rhg-modal-filters {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  &-content {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    @media (min-width: 992px) {
      width: 1000px;
      height: 784px;
    }
  }

  &-header {
    display: flex;
    justify-content: space-between;
    padding: 36px 36px 0px 36px;
    margin-bottom: 20px;

    span {
      font-size: 24px;
      font-weight: 700;
      line-height: 26px;
      text-align: left;
      color: #242424;
    }

    i {
      cursor: pointer;
    }
  }

  &-body {
    padding: 36px 36px 25px 36px;
    margin-bottom: 20px;
    overflow: scroll;
  }

  &-bottom {
    width: 100%;
    position: absolute;
    bottom: 0px;
    background: white;

    .rhg-modal-filter-buttons {
      display: flex;
      justify-content: flex-end;
      padding: 24px 36px 24px 36px;

      @media (max-width: 992px) {
        justify-content: space-between;
      }

      .rhg-modal-filters-clear {
        text-transform: uppercase;
        color: #C62525;
        font-size: 14px;
        font-weight: 700;
        line-height: 18px;
        border: 0;
        background-color: white;
        margin-right: 10px;

        &:hover {
          color: #9E0918;
          text-decoration: underline;
        }
      }

      .rhg-modal-filters-done {
        color: white;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        background-color: #C62525;
        padding: 13px 24px;
        border-radius: 24px;
        border: 0;
        max-width: fit-content;
        min-width: 180px;
        height: 50px;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        &-numHotels {
          text-transform: lowercase;
          font-weight: normal;
        }
      }
    }
  }
}

.rhg-modal-filter {
  margin-bottom: 40px;
}

.rhg-separator {
  border: 0.7px solid #D8D8D8;
  opacity: 0.25;
  background-color: #686868;
}

.modal-fade-enter-active {
  transition: opacity 0.5s;
}
.modal-fade-leave-active {
  transition: opacity 0.5s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

.spinner-border {
  height: 2.5rem;
  width: 2.5rem;
  border-width: 0.2em;
  color: white;
}
</style>
